import { useTranslation } from "react-i18next";
import ContentHeading from "../content-heading";
// State Management => Add this when a ZAR price list is available
// import { useAppSelector } from "@/redux/hooks";
// import { getCurrency } from "@/redux/slices/billing";
// Tailwind CSS
import {
  wrapper,
  image,
  content,
  subHeading,
  button,
  buttonIcon,
} from "./style/hero";

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const pricingPDF =
    "/assets/documents/pricing/CUS-FR-03%20Price%20List%20USD%202024-04-08%20v3.0.2.pdf";
  // const currency = useAppSelector(getCurrency); Add this when a ZAR price list is available

  return (
    <section
      className={wrapper}
      title={t(`pricing.seo.title`)}
      aria-label={t(`pricing.seo.aria-label`)}
    >
      <img
        className={image}
        srcSet={`
						/assets/images/pages/pricing/hero/small.webp 420w,
						/assets/images/pages/pricing/hero/small.jpg 420w,
						/assets/images/pages/pricing/hero/medium.webp 733w,
						/assets/images/pages/pricing/hero/medium.jpg 733w,
						/assets/images/pages/pricing/hero/large.webp 1465w,
						/assets/images/pages/pricing/hero/large.jpg 1465w,
					`}
        sizes="(max-width:736px) 420px, (max-width:1280px) 800px, 1500px"
        src={`/assets/images/pages/pricing/hero/small.jpg`}
        alt="Collection of hearX Group's hearing healthcare solutions"
      />
      <div className={content}>
        <ContentHeading
          h="p"
          className="mobile:justify-center tablet:justify-start"
          backdropPosition="left-4"
          fontSize="mobile:text-2xl tablet:text-4xl"
          background="bg-primary bg-opacity-40"
        >
          {t("pricing.heading")}
        </ContentHeading>
        <p className={subHeading}>{t("pricing.sub-heading")}</p>
        <a href={pricingPDF} target="_blank">
          <button className={button} type="button">
            {/*
					Add this when a ZAR price list is available
					<img className={buttonIcon} src={`/assets/icons/flags/${currency.toLowerCase()}.png`} alt="" />
                    {t(`pricing.button.${currency.toLowerCase()}`)}
					*/}
            <img
              className={buttonIcon}
              src={`/assets/icons/flags/usd.png`}
              alt=""
            />
            {t(`pricing.button.usd`)}
          </button>
        </a>
      </div>
    </section>
  );
};

export default Hero;
